import { ContractLight, VisibleColumnSpec } from "@/types";

export const BULK_EDIT_VISIBLE_COLUMNS: VisibleColumnSpec<ContractLight, "price" | "actions">[] = [
  "id",
  "contractDate",
  "name",
  "contractProduct",
  "price",
];
